import { CSSProperties } from "react";

export default {
    td: {
        padding: "0.8em 0.4em",
        position: "relative"
    } as CSSProperties
};
